import { Paragraph, CardName } from 'library/styles/text';
import {
  ImageWrapper as Item,
  Image,
  TextWrapper,
} from 'library/components/view-mode/list/item/styles';
import {
  Content,
  Text,
  ItemContainer,
} from './styles';
import withModalContainer from './hocs/with-modal-container';
import getThumbnailImageSource from '../../helpers/get-thumbnail-image-source';

const DuplicatesConfirm = ({
  text, data = [],
}) => {
  const renderItem = (props) => {
    const [image] = props?.images || [{ url: '' }];
    const url = getThumbnailImageSource(image);

    return (
      <Item key={props.id}>
        <Image
          key={props.id}
          url={url}
        />
        <TextWrapper>
          <CardName>{props.name}</CardName>
          <Paragraph>{props.category_name}</Paragraph>
          <Paragraph>{props.manufacturer_name}</Paragraph>
        </TextWrapper>
      </Item>
    );
  };

  return (
    <Content>
      <Text style={{ margin: '25px 10px 40px 10px' }}>{text}</Text>
      <ItemContainer>
        {data.map(renderItem)}
      </ItemContainer>
    </Content>
  );
};

export default withModalContainer(DuplicatesConfirm);
